import { useUBL } from '@common/log-manager';

export const useRollingBannerUBL = () => {
  const sendUBL = useUBL();

  const clickBannerUBL = (param: { productId: string; objectId: string; objectIdx: number }) => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'event_banner',
      object_type: 'banner',
      object_id: param.objectId,
      object_idx: param.objectIdx,
      data: { product_id: param.productId },
    });
  };

  const impressBannerUBL = (param: { productId: string; objectId: string; objectIdx: number }) => {
    sendUBL({
      category: 'impression',
      navigation: 'product_detail',
      object_section: 'event_banner',
      object_type: 'banner',
      object_id: param.objectId,
      object_idx: param.objectIdx,
      data: { product_id: param.productId },
    });
  };
  return { clickBannerUBL, impressBannerUBL };
};
